import React from 'react';
import * as Styled from './ALabel.styles';
import { ALabelSize, type ALabelProps } from './ALabel.types';
import clsx from 'clsx';
import { useSanitize } from '../../hooks/useSanitize';

const COMPONENT_NAME = 'a-web-ui-kit-ALabel';
const TEST_ID = 'web-ui-kit-ALabel';

const ALabelAllowedTags = ['b', 'strong', 'i', 'em', 'u', 's', 'del', 'sub', 'sup', 'mark', 'small', 'big', 'span'];
const sanitizeOpts = { ALLOWED_TAGS: ALabelAllowedTags };

function ALabel({ size = ALabelSize.S, text, className, ...rest }: ALabelProps) {
  const { isDangerouslySet, result: cleanText } = useSanitize(text, sanitizeOpts);

  return isDangerouslySet ? (
    <Styled.ALabelWrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      size={size}
      className={clsx(className, 'm-ellipsis-1line')}
      {...rest}
      dangerouslySetInnerHTML={{ __html: cleanText }}
    />
  ) : (
    <Styled.ALabelWrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      size={size}
      className={clsx(className, 'm-ellipsis-1')}
      {...rest}
    >
      {cleanText}
    </Styled.ALabelWrapper>
  );
}

export { ALabel, ALabelSize, TEST_ID as A_LABEL_TEST_ID };
